import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query GetUsers($filter: UserFilter) {
    users(filter: $filter) {
      id
      firstName
      lastName
      email
    }
  }
` 